import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import AppLogoLoading from '../../sc-logo';
import ProductTypeForm from "./ProductTypeForm";
import { withStyles, Dialog } from "@material-ui/core";
import * as Yup from "yup";
import { parseURL } from "../../sc-utilities";
import * as actions from './store/productTypeActions';
import History from "../../../History";
import { hasPermission } from "../../sc-utilities";


const styles = theme => ({
    submit: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },

    cancel: {
        width: "250px",
        margin: "10px"
    }
});

const ProductTypeEdit = props => {
    const { classes, loading, activeCustomer, translations, onLoadProductTypeInit, onEditProductType, onLoadProductType, productType, permissions } = props;
    const [editData, setEditData] = useState({ loadingData: true });

    useEffect(() => {
        const fetchData = async () => {
            await onLoadProductType({ ActiveCustomerID: activeCustomer, ProductTypeID: parseURL(window.location.href).productTypeID })
        }
        fetchData();
        return () => {
            onLoadProductTypeInit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (productType && Object.keys(productType).length > 0) {
            setEditData({ loadingData: false });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [productType]);


    const handleSubmit = async data => {
        let result = await onEditProductType({ ...data, ActiveCustomerID: activeCustomer, ProductTypeID: parseURL(window.location.href).productTypeID });
        if (result) {
            setEditData({ loadingData: true });
            History.goBack()
        }
    };

    const cancelHandler = () => {
        History.goBack();
    };
    let initialValues = {
        Name: productType && productType.Name ? productType.Name : '',
        Key: productType && productType.Key ? productType.Key : ''
    };

    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
            Key: Yup.string().required("Required")
        },
        FormTitle: translations["edit_product_type"] || "Edit product type",
        ButtonSubmit: hasPermission(permissions, 'product_type_save') ? {
            Title: translations["save"] || "SAVE"
        } : null,
        ButtonCancel: {
            Title: translations["cancel"] || "CANCEL",
            handleCancel: cancelHandler
        }
    };

    return (
        !editData.loadingData ?
            <ProductTypeForm
                formSettings={formSettings}
                initialValues={initialValues}
                handleSubmit={handleSubmit}
                loading={loading}
                translations={translations}
            /> :
            <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={editData.loadingData}
                PaperProps={{
                    classes: {
                        root: classes.submit
                    }
                }}
            >

                <AppLogoLoading />
            </Dialog>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        loading: state.admin.productType.editing,
        productType: state.admin.productType.loaded,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || []
    };
};
const mapDispatchToProps = dispatch => {
    return {
        onEditProductType: data => dispatch(actions.editProductType(data)),
        onLoadProductType: data => dispatch(actions.loadProductType(data)),
        onLoadProductTypeInit: () => dispatch(actions.loadProductTypeInit()),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(ProductTypeEdit));


/**
 *  Translations
 *      edit_colli_type
 *
 */
